import { call, put, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import { signupForAlerts } from 'yoda-interfaces/lib/MyAlerts/MyAlerts';

import {
    MYALERTS_SUBSCRIBE_REQUEST,
    MYALERTS_SUBSCRIBE_SUCCESS,
    MYALERTS_SUBSCRIBE_ERROR,
    MYALERTS_LOADER,
} from '../actionTypes/MyAlertsActionTypes';

function* signupForAlertsSaga(action) {
    try {
        const myAlerts = yield call(signupForAlerts, action);
        const userStatus = get(myAlerts, 'userStatus');
        const { sourceMiniPDP } = action.payload;
        yield put({
            type: MYALERTS_LOADER,
            payload: {
                isLoader: false,
                sourceMiniPDP,
            },
        });
        if (userStatus === '201' || userStatus === '200') {
            yield put({
                type: MYALERTS_SUBSCRIBE_SUCCESS,
                payload: {
                    response: myAlerts.response,
                    isSuccess: true,
                    isFailuire: false,
                    sourceMiniPDP,
                },
            });
        } else {
            yield put({
                type: MYALERTS_SUBSCRIBE_ERROR,
                payload: {
                    response: myAlerts.response,
                    isSuccess: false,
                    isFailuire: true,
                    sourceMiniPDP,
                },
            });
        }
    } catch (error) {
        yield put({
            type: MYALERTS_SUBSCRIBE_ERROR,
            payload: {
                response: error,
                isSuccess: false,
                isFailuire: true,
                sourceMiniPDP: action.payload.sourceMiniPDP,
            },
        });
    }
}

const watchMyAlertsSaga = function* watchMyAlertsSaga() {
    yield takeLatest(MYALERTS_SUBSCRIBE_REQUEST, signupForAlertsSaga);
};

watchMyAlertsSaga.sagaName = 'signupForAlerts';

export default watchMyAlertsSaga;
